module.exports = __webpack_public_path__ + "static/04-015116ce993c802ce1163d25e9e5d419.png";